import styled, { css } from 'styled-components';
import { fromMd } from '../../../../constants/breakpoints';
import { backgroundImageToScreenRatioAtDesktopBreakpoint, spacingBetweenIconAndInitialsViewWidthUnits, } from '../dimensions';
export const Body = styled.div `
  display: flex;
  align-items: center;
  position: absolute;
  z-index: ${o => o.theme.zIndex.foregroundContent};
`;
export const Image = styled.img(o => css `
    height: calc(clamp(8px, 3.5cqw, 48px) * ${o.scale});
    width: calc(clamp(8px, 3.5cqw, 48px) * ${o.scale});
    filter: var(--embroidery-icon-filter);
  `);
export const InitialsWrapper = styled.div `
  margin-left: ${spacingBetweenIconAndInitialsViewWidthUnits}vw;
  filter: var(--embroidery-initials-filter);
  will-change: filter;
  ${fromMd} {
    margin-left: ${spacingBetweenIconAndInitialsViewWidthUnits *
    backgroundImageToScreenRatioAtDesktopBreakpoint}vw;
  }
`;
export const Initials = styled.span `
  display: inline-block;
  color: ${props => props.color};
  font-family: Helvetica, Arial, sans-serif;
  font-weight: bold;
  font-size: clamp(8px, 2vw, 32px);
  letter-spacing: 0.69px;

  ${fromMd} {
    font-size: clamp(8px, 1vw, 32px);
  }
`;
//# sourceMappingURL=styles.js.map